import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Set a countdown for 4 hours from now, resetting if it expires
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 37,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          return {
            hours: 4,
            minutes: 0,
            seconds: 0
          }; // Reset
        }
        let h = prev.hours;
        let m = prev.minutes;
        let s = prev.seconds - 1;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-3 text-center my-6" data-id="element-13">
      <div className="flex flex-col items-center" data-id="element-14">
        <div className="bg-zinc-900 border border-pink-500/30 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-pink-500 shadow-[0_0_15px_rgba(236,72,153,0.15)]" data-id="element-15">
          {format(timeLeft.hours)}
        </div>
        <span className="text-xs text-zinc-500 mt-1 uppercase font-semibold tracking-wider" data-id="element-16">
          Horas
        </span>
      </div>
      <span className="text-2xl font-bold text-zinc-700 -mt-5" data-id="element-17">:</span>
      <div className="flex flex-col items-center" data-id="element-18">
        <div className="bg-zinc-900 border border-pink-500/30 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-pink-500 shadow-[0_0_15px_rgba(236,72,153,0.15)]" data-id="element-19">
          {format(timeLeft.minutes)}
        </div>
        <span className="text-xs text-zinc-500 mt-1 uppercase font-semibold tracking-wider" data-id="element-20">
          Min
        </span>
      </div>
      <span className="text-2xl font-bold text-zinc-700 -mt-5" data-id="element-21">:</span>
      <div className="flex flex-col items-center" data-id="element-22">
        <div className="bg-zinc-900 border border-pink-500/30 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-pink-500 shadow-[0_0_15px_rgba(236,72,153,0.15)]" data-id="element-23">
          {format(timeLeft.seconds)}
        </div>
        <span className="text-xs text-zinc-500 mt-1 uppercase font-semibold tracking-wider" data-id="element-24">
          Seg
        </span>
      </div>
    </div>;
}